import { NgClass, CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'icon';
export type ButtonSize = 'sm' | 'md' | 'lg' | 'icon';

@Component({
  selector: 'app-cnfpc-button',
  standalone: true,
  imports: [CommonModule, NgClass],
  templateUrl: './cnfpc-button.component.html',
  styleUrl: './cnfpc-button.component.scss',
})
export class CnfpcButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() disabled: boolean = false;
  @Input() active: boolean = false;

  /** Icon name for Material Icons */
  @Input() icon?: string;

  @Output() onClick = new EventEmitter<MouseEvent>();

  getVariantClasses(): string {
    const variants: Record<ButtonVariant, string> = {
      icon: 'p-2 transition-colors',
      primary: this.active
        ? 'border-4 border-cnfpc-primary-black font-semibold bg-cnfpc-primary-black px-4 py-2 text-cnfpc-secondary-white transition-colors'
        : 'border-4 border-cnfpc-primary-darkest font-semibold bg-cnfpc-primary-darkest px-4 py-2 text-cnfpc-secondary-white transition-colors hover:border-cnfpc-primary-dark hover:bg-cnfpc-primary-dark hover:text-cnfpc-secondary-white',
      secondary: this.active
        ? 'border-4 border-cnfpc-secondary-black font-semibold bg-cnfpc-secondary-white px-4 py-2 text-cnfpc-secondary-black transition-colors'
        : 'border-4 border-cnfpc-primary-darkest font-semibold bg-cnfpc-secondary-white px-4 py-2 text-cnfpc-secondary-black transition-colors hover:border-cnfpc-primary-dark',
    };
    return variants[this.variant];
  }

  getSizeClasses(): string {
    const sizes: Record<ButtonSize, string> = {
      icon: 'px-1 py-1.5',
      sm: 'px-4 py-1.5 text-sm',
      md: 'px-6 py-2 text-base',
      lg: 'px-8 py-3 text-lg',
    };
    return sizes[this.size];
  }
}
